import { RefObject } from "react";
import { useTranslation } from "react-i18next";
import { Rototilt } from "../../interfaces/api/Rototilt";
import ProductSeperator from "../Products/ProductSeperator";
import Tiltrotators from "./Tiltrotators";

interface TiltrotatorsProductProps {
  onTiltrotatorChange(rototilt: Rototilt): void;
  refTiltrotators: RefObject<HTMLDivElement>;
  selectedTiltrotator: Rototilt;
  tiltrotators: Rototilt[];
}

const TiltrotatorsProduct = ({
  onTiltrotatorChange,
  refTiltrotators,
  selectedTiltrotator,
  tiltrotators,
}: TiltrotatorsProductProps) => {
  const { t } = useTranslation(["tiltrotator"]);

  return (
    <div ref={refTiltrotators}>
      <ProductSeperator />
      <h3>
        {t("choosetiltrotator")}
        <sup>*</sup>
      </h3>
      <Tiltrotators
        onTiltrotatorChange={onTiltrotatorChange}
        selectedTiltrotator={selectedTiltrotator}
        tiltrotators={tiltrotators}
      />
    </div>
  );
};

export default TiltrotatorsProduct;
